import {
    AUTHENTICATING_EMAIL_REQUEST, AUTHENTICATING_EMAIL_SUCCEDDED, AUTHENTICATING_EMAIL_FAILED,
} from './actionTypes.jsx';

import { activatingIntegrationSuccedded } from './integrations';
import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const INTEGRATION_BASE_URL = `${apiUrl}/api/2.0/integrations`;

export function authenticateAccount(code, integrationType) {
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
        code: code
    }

    let url = buildUrl(INTEGRATION_BASE_URL, {
      path: `${integrationType}`,
    });

    return axios({
      method: 'POST',
      url: url,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      params: data
    })
    .then((response) => {
        dispatch(authenticatingAccountSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
        dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}

function authenticatingAccount() {
    return {
        type: AUTHENTICATING_EMAIL_REQUEST,
        payload: {}
    }
}

function authenticatingAccountSuccedded(json) {
    return {
        type: AUTHENTICATING_EMAIL_SUCCEDDED,
        payload: json
    }
}

function authenticatingAccountFailed(error) {
    return {
        type: AUTHENTICATING_EMAIL_FAILED,
        payload: error
    }
}